import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "submitButton", "form", "recaptchaToken",
    "technologyAutocomplete", "technologiesOperator", "technologiesHidden",
    "category", "languageAutocomplete", "languagesHidden",
    "popularity", "popularityHidden", "popularityStatus",
    "selectionError", "selectionErrorContainer"
  ]

  static values = { limit: Number, maxLimit: Number }

  connect() {
    var _this = this
    // Initialize the multirange
    _this.multirange(document.querySelector("input[type=range][multiple]:not(.multirange)"))

    // Autocompletes
    _this.technologyAutocomplete()
    _this.languageAutocomplete()

    // Page loading
    _this.loadParameters()

    $("input[type='range']").on("change", function() {
      _this.displayPopularity()
      return _this.updateSelection()
    })

    $(_this.categoryTarget).on("change", () => _this.updateSelection())
  }

  technologyOperatorChange(e) {
    var _this = this

    if (_this.technologiesHiddenTarget.value.split(",").length > 1) {
      return _this.updateSelection()
    }
  }

  technologyAutocomplete() {
    var _this = this

    $(this.technologyAutocompleteTarget).autocomplete({
      minChars: 1,
      autoSelectFirst: true,
      triggerSelectOnValidInput: false,
      formatResult: function(suggestion) {
        return `<div><strong>${suggestion.value}</strong> ${suggestion.category}</div>`
      },
      lookup: function(query, done) {
        var items = []
        Object.keys(gon.technologies).forEach(function(i) {
          if (gon.technologies[i].name.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
            items.push({
              id: gon.technologies[i].id,
              value: gon.technologies[i].name,
              category: gon.technologies[i].category
            })
          }
        })
        done({ suggestions: items })
      },
      onSelect: function (suggestion) {
        _this.addTechnology(suggestion.id, suggestion.value)
        _this.updateTechnologiesInput()
      }
    })
  }

  addTechnology(id, name) {
    var _this = this

    if (!$("#technologies-selected .label-selected[data-technology-id='" + id + "']").length) {
      $("#technologies-selected").append("<div class='label-selected' data-technology-id='" + id + "'><div class='close-selected-label'>&times</div><strong>" + name + "</strong></div>")
      $(".close-selected-label").on("click", function() {
        $(this).parent().remove()
        _this.updateTechnologiesInput()
        if (_this.technologiesHiddenTarget.value.split(",").length <= 1) {
          return $("#close-technologies").hide()
        }
      })

      if ($("#technologies-selected .label-selected").length > 1) {
        $("#close-technologies").show()

        return $("#close-technologies").on("click", function() {
          $(this).hide()
          _this.technologiesHiddenTarget.value = ""
          $("#technologies-selected .label-selected").remove()
          $(_this.technologiesOperatorTarget).val("and")
          return _this.updateSelection()
        })
      }
    }
  }

  updateTechnologiesInput() {
    var _this = this

    let technologies = new Array
    $("#technologies-selected .label-selected").each(function(index) {
      const code = $(this).data().technologyId
      return technologies.push(code)
    })
    technologies = technologies.join(",")
    _this.technologiesHiddenTarget.value = technologies
    return _this.updateSelection()
  }

  // Languages
  //
  languageAutocomplete() {
    var _this = this

    $(this.languageAutocompleteTarget).autocomplete({
      minChars: 1,
      autoSelectFirst: true,
      triggerSelectOnValidInput: false,
      formatResult: function(suggestion) {
        return `<div><strong>${suggestion.value}</strong></div>`
      },
      lookup: function(query, done) {
        var items = []
        Object.keys(gon.languages).forEach(function(i) {
          items.push({
            code: gon.languages[i].code,
            value: gon.languages[i].language
          })
        })
        done({ suggestions: items })
      },
      onSelect: function (suggestion) {
        _this.addLanguage(suggestion.code, suggestion.value)
        _this.updateLanguagesInput()
      }
    })
  }

  addLanguage(code, language) {
    var _this = this

    if (!$(`#languages-selected .label-selected[data-language-code=${code}]`).length) {
      $("#languages-selected").append(`<div class='label-selected' data-language-code='${code}'><div class='close-selected-label'>&times</div><strong>${language}</strong></div>`)
      $(".close-selected-label").on("click", function() {
        $(this).parent().remove()
        _this.updateLanguagesInput()
        if ($("#languages-selected .label-selected").length <= 1) {
          return $("#close-languages").hide()
        }
      })

      if ($("#languages-selected .label-selected").length > 1) {
        $("#close-languages").show()

        return $("#close-languages").on("click", function() {
          $(this).hide()
          $(_this.languagesHiddenTarget).val("")
          $("#languages-selected .label-selected").remove()
          return _this.updateSelection()
        })
      }
    }
  }

  updateLanguagesInput() {
    var _this = this

    let languages = new Array
    $("#languages-selected .label-selected").each(function(index) {
      const code = $(this).data().languageCode
      return languages.push(code)
    })
    languages = languages.join(",")
    $(_this.languagesHiddenTarget).val(languages)
    return _this.updateSelection()
  }


  // Popularity
  //
  displayPopularity() {
    // It's this input that will be POSTed
    $(this.popularityHiddenTarget).val($(this.popularityTarget).val())

    const range = $(".popularity-input").val().split(",")

    if (range[0] !== range[1]) {
      return $(this.popularityStatusTarget).text(range[0] + " - " + range[1])
    } else {
      return $(this.popularityStatusTarget).text("Please select an interval > 1")
    }
  }

  // URL parameters management
  //
  loadParameters() {
    var _this = this

    const technologies_operator = App.findGetParameter("technologies_operator")
    if (technologies_operator === "or") {
      _this.technologiesOperatorTarget.value = "or"
    }

    const technologies = App.findGetParameter("technologies")
    if ((technologies != null) && (technologies !== "")) {
      technologies.split(",").forEach(function(technology_id, index) {
        const selected = gon.technologies.find(el => el.id === parseInt(technology_id))
        _this.addTechnology(selected.id, selected.name)
        return _this.technologiesHiddenTarget.value = technologies
      })
    }

    const category = App.findGetParameter("category")
    if ((category != null) && (category !== "")) {
      $(_this.categoryTarget).val(category)
    }

    const languages = App.findGetParameter("languages")
    if ((languages != null) && (languages !== "")) {
      languages.split(",").forEach(function(language_code, index) {
        const selected = gon.languages.find(el => el.code === language_code)
        _this.addLanguage(selected.code, selected.language)
        return $(_this.languagesHiddenTarget).val(languages)
      })
    }

    let popularity = App.findGetParameter("popularity")
    if ((popularity != null) && (popularity !== "")) {
      popularity = popularity.replace("[", "").replace("]", "")
      $("#popularity-input").val(popularity)
      _this.displayPopularity()
    }

    return _this.updateSelection(false)
  }


  updateUrl() {
    var _this = this

    var parameters = ""

    if (_this.technologiesHiddenTarget !== "") {
      parameters = App.addUrlParam(parameters, "technologies", _this.technologiesHiddenTarget.value)
    }


    if (_this.technologiesOperatorTarget.value === "or") {
      parameters = App.addUrlParam(parameters, "technologies_operator", "or")
    }


    if ($(_this.categoryTarget).val() !== "") {
      parameters = App.addUrlParam(parameters, "category", $(_this.categoryTarget).val())
    }


    if ($(_this.languagesHiddenTarget).val() !== "") {
      parameters = App.addUrlParam(parameters, "languages", $(_this.languagesHiddenTarget).val())
    }

    parameters = App.addUrlParam(parameters, "popularity", "["+$(".popularity-input").val()+"]")

    const newUrl = window.location.pathname + parameters
    const oldUrl = window.location.pathname + window.location.search

    if (newUrl != oldUrl) {
      return history.pushState({}, "Hunter - Generation of a list of domain names", newUrl)
    }
  }


  updateCompaniesCount() {
    var _this = this
    const technologies_operator = _this.technologiesOperatorTarget.value
    const technologies = _this.technologiesHiddenTarget.value
    const category = $(_this.categoryTarget).val()
    const languages = $(_this.languagesHiddenTarget).val()
    const popularity = $(".popularity-input").val()

    $(".domains-loader").css({ display: "inline-block" })
    $(".domains-number").hide()

    return $.ajax({
      url: `/v2/domain-count?technologies_operator=${technologies_operator}&technologies=${technologies}&categories=${category}&languages=${languages}&popularity=[${popularity}]`,
      headers: {"Email-Hunter-Origin": "techlookup"},
      type: "GET",
      data: { format: "json" },
      dataType: "json",
      success(json) {
        $(".domains-loader").hide()
        $(".domains-number").show()
        const count = json.data.total
        $(".domains-number span").text(App.numberWithCommas(count))

        if (count > 50000) {
          $("#count-field").val(50000)
        } else {
          $("#count-field").val(count)
        }

        $(_this.submitButtonTarget).prop("disabled", false)

        if (count === 0) {
          $(_this.selectionErrorTarget).text("The selection is empty.")
          $(_this.selectionErrorContainerTarget).slideDown(200)
          $(_this.submitButtonTarget).prop("disabled", true)
        }

        if (!technologies) {
          $(_this.selectionErrorTarget).text("Please select at least one technology.")
          $(_this.selectionErrorContainerTarget).slideDown(200)
          return $(_this.submitButtonTarget).prop("disabled", true)
        } else if (count > _this.limitValue) {
          if (_this.limitValue == _this.maxLimitValue) {
            var upgradeHint = ""
          }
          else {
            var upgradeHint = `<br><a href='/welcome/upgrade?from=techlookup' target='_blank'>Upgrade</a> to a premium plan to increase the limit to ${App.numberWithCommas(_this.maxLimitValue)} websites.`
          }
          $(_this.selectionErrorTarget).text(`The file will be limited to the first ${App.numberWithCommas(_this.limitValue)} websites.`)
          $(_this.selectionErrorTarget).append(upgradeHint)
          return $(_this.selectionErrorContainerTarget).slideDown(200)
        }
      }
    })
  }


  updateListName() {
    var _this = this

    let category, quantifier
    const popularity = $(".popularity-input").val().split(",")

    if ((popularity[1] - popularity[0]) === 5) {
      quantifier = "All the "
    } else if (((popularity[1] - popularity[0]) <= 2) && (popularity[1] <= 2)) {
      quantifier = "Small "
    } else if (((popularity[1] - popularity[0]) <= 2) && (popularity[1] <= 3)) {
      quantifier = "Medium "
    } else if (((popularity[1] - popularity[0]) <= 2) && (popularity[0] >= 4)) {
      quantifier = "Popular "
    } else {
      quantifier = ""
    }

    if ($(_this.categoryTarget).val() !== "") {
      category = `${$("#category-input option:selected").text()} websites `
    } else {
      category = "Websites "
    }

    let technologies = $("#technologies-selected .label-selected")
    if (technologies.length === 1) {
      technologies = `using ${technologies.find("strong").text()}`
    } else if (technologies.length === 2) {
      technologies = `using ${technologies.find("strong").first().text()} ${_this.technologiesOperatorTarget.value} ${technologies.find("strong").last().text()}`
    } else if (technologies.length > 2) {
      technologies = `using ${technologies.find("strong").first().text()} ${_this.technologiesOperatorTarget.value} ${technologies.length - 1} other technologies`
    } else {
      technologies = ""
    }

    let languages = $(_this.languagesHiddenTarget).val().split(",")
    if ((languages.length === 1) && languages[0]) {
      languages = ` (${languages[0].toUpperCase()})`
    } else if (languages.length === 2) {
      languages = ` (${languages[0].toUpperCase()} & ${languages[1].toUpperCase()})`
    } else if (languages.length > 2) {
      languages = ` (${languages.length} languages)`
    } else {
      languages = ""
    }

    return $("#name-field").val(`${quantifier}${category}${technologies}${languages}`)
  }

  updateSelection(withUrl = true) {
    this.updateCompaniesCount()
    this.updateListName()

    if (withUrl) {
      this.updateUrl()
    }

    $(this.submitButtonTarget).prop("disabled", true)
    $(this.selectionErrorContainerTarget).slideUp(200)
    return $(this.selectionErrorTarget).text("")
  }

  // This function is based on: https://projects.verou.me/multirange
  multirange(input) {
    var supportsMultiple = self.HTMLInputElement && "valueLow" in HTMLInputElement.prototype

    var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")

    if (supportsMultiple || input.classList.contains("multirange")) {
      return
    }

    var value = input.getAttribute("value")
    var values = value === null ? [] : value.split(",")
    var min = +(input.min || 0)
    var max = +(input.max || 100)
    var ghost = input.cloneNode()

    input.classList.add("multirange", "original")
    ghost.classList.add("multirange", "ghost")

    input.value = values[0] || min + (max - min) / 2
    ghost.value = values[1] || min + (max - min) / 2

    input.parentNode.insertBefore(ghost, input.nextSibling)

    Object.defineProperty(input, "originalValue", descriptor.get ? descriptor : {
      // Because of Safari.
      get: function() { return this.value },
      set: function(v) { this.value = v }
    })

    Object.defineProperties(input, {
      valueLow: {
        get: function() { return Math.min(this.originalValue, ghost.value) },
        set: function(v) {
          this.originalValue = v
          update()
        },
        enumerable: true
      },
      valueHigh: {
        get: function() { return Math.max(this.originalValue, ghost.value) },
        set: function(v) {
          ghost.value = v
          update()
        },
        enumerable: true
      }
    })

    if (descriptor.get) {
      // Because of Safari.
      Object.defineProperty(input, "value", {
        get: function() { return this.valueLow + "," + this.valueHigh },
        set: function(v) {
          var values = v.split(",")
          this.valueLow = values[0]
          this.valueHigh = values[1]
        },
        enumerable: true
      })
    }

    if (typeof input.oninput === "function") {
      ghost.oninput = input.oninput.bind(input)
    }

    function update() {
      ghost.style.setProperty("--low", 100 * ((input.valueLow - min) / (max - min)) + 1 + "%")
      ghost.style.setProperty("--high", 100 * ((input.valueHigh - min) / (max - min)) - 1 + "%")
    }

    ghost.addEventListener("mousedown", function passClick(evt) {
      // Find the horizontal position that was clicked
      let clickValue = min + (max - min) * evt.offsetX / this.offsetWidth;
      let middleValue = (input.valueHigh + input.valueLow) / 2

      if ( (input.valueLow == ghost.value) == (clickValue > middleValue) ) {
        // Click is closer to input element and we swap thumbs
        input.value = ghost.value
      }
    })

    input.addEventListener("input", update)
    ghost.addEventListener("input", update)

    update()
  }

  // Submit is triggered when the user clicks on the form. It obtains a code
  // from Recaptcha which is verified in Rails.
  submit(e) {
    var _this = this
    e.preventDefault()

    grecaptcha.execute(gon.recaptcha_site_key, { action: "domains_list_create" }).then(function(token) {
      _this.recaptchaTokenTarget.value = token
      _this.formTarget.submit()

    })
  }
}
